export default {
  CHINATitle: '一加社区 10 周年加油报告',
  INTitle: 'For Example, You',
  GLOBALTitle: 'Ollie Elemental Collection Worldwide Wishes Contest',
  PARISTitle: 'A Decade of Never Settle',
  saveImgSuccess: 'Saved. Share on Instagram Story.',
  CHINADescription: "定制专属你的报告",
  PARISDescription: "It's our 10th Anniversary. Let's look back at our journey together.",
  GLOBALDescription: "Join the Ollie Elemental Collection to create, customize, and share your wishes worldwide.",
  INDescription: "Celebrate the year with #TogetherwithOPPO! I just generated my personalized OPPO Community Annual Milestones Report and you can too for 2023. Don’t miss out on the chance to win the incredible Find N3, simply generate and share your report.",
  ar: 'Create your own Ollie in AR and win the Find N3',
  draw: 'Draw your luck at the OPPO Community Carnival 2023',
  homeCarnivalTitleGLOBAL: 'Join the OPPO Community Carnival 2023',
  homeCarnivalTitleIN: 'Join the OPPO Community Carnival 2023',
  carnival: 'Carnival 2023',
} 